module.exports = __webpack_public_path__ + "static/media/javitott_meglevo_szerzigeny3.cc0e08e3.jpg";